import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxRoleGuardDirective } from './rx-role-guard.directive';

@NgModule({
  imports: [CommonModule, RxRoleGuardDirective],
  exports: [RxRoleGuardDirective],
})
export class RxRoleGuardModule {}
